export const endpoints = {
    submitForm: '/forms/submit/building/:buildingId/formtype/:formType',
    getAllFormsRecords: '/forms/building/:buildingId',
    downloadForm: '/forms/download/formid/:formId',
};

export function resolveEndpoint(
  endpoint: string,
  params: Record<string, string | number>
): string {
  return Object.entries(params).reduce((resolvedEndpoint, [key, value]) => {
    return resolvedEndpoint.replace(`:${key}`, String(value));
  }, endpoint);
}
